/**
 * DOM helpers. Node references are looked up once and cached; the tick loop
 * only ever assigns to .textContent on a ref it already holds.
 *
 * Never rebuild innerHTML on tick.
 */

export function byId<T extends HTMLElement = HTMLElement>(id: string): T {
  const node = document.getElementById(id);
  if (node === null) throw new Error(`Missing element #${id}`);
  return node as T;
}

/** Assigns only when the value actually changed, to avoid needless layout. */
export function setText(node: HTMLElement, value: string): void {
  if (node.textContent !== value) node.textContent = value;
}

/** Toggles the `disabled` attribute only on change. */
export function setDisabled(node: HTMLButtonElement, disabled: boolean): void {
  if (node.disabled !== disabled) node.disabled = disabled;
}
